export const CHANGE_SETTINGS = 'CHANGE_SETTINGS'

export const change = settings => {
  return ({ type: CHANGE_SETTINGS, settings })
}